// extracted by mini-css-extract-plugin
export var body = "_l5-0";
export var sectionHeader = "_l5-4";
export var shortcutColumns = "_l5-2";
export var shortcutList = "_l5-1";
export var shortcutSection = "_l5-3";